import Axios from "axios";
import { APIBASE_URL, BANNER_URL } from "../config/cacheKey";
import { IBannersResponse } from "../models/banner.model";
import { ApiResultModel } from "../models/common.model";

export const GetBanners = (): Promise<IBannersResponse[]> => {
    return Axios.get<ApiResultModel<IBannersResponse[]>>(
        APIBASE_URL + BANNER_URL + '/GetBanners',

    ).then((result) => {
        return result.data.data;
    });
};









